import axios from "axios";
import { encryptData, decryptData } from "../../utils/helper";
import useUser from "../../hooks/useUser";
import { useNavigate } from "react-router-dom";

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const TOKEN = localStorage.getItem("hollypills_token");
export const HEADERS = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("hollypills_token") || ""}`,
};

const HttpService = () => {
  const { logout } = useUser();
  const navigate=useNavigate();
  const httpRequest = (method, url, data = {}, params) =>
    new Promise((resolve, reject) => {
      data = encryptData(data);
      if (params) {
        params = encryptData(params);
      }
      axios({
        method,
        url: `${BASE_URL}/${url}`,
        data: { reqData: data },
        params: { reqData: params },
        headers: HEADERS,
      })
        .then((response) => {
          resolve(decryptData(response.data));
        })
        .catch((err) => {
          if (err.response?.data) {
            reject({ ...err.response, data: decryptData(err.response.data) });
            // navigate('/not-found')
          } else {
            reject({
              data: { message: err?.message || "Unknown Error Occurred" },
            });
          }
        });
    });

  const httpDecryptRequest = (method, url, data = {}, params) =>
    new Promise((resolve, reject) => {
      data = encryptData(data);
      if (params) {
        params = encryptData(params);
      }
      axios({
        method,
        url: `${BASE_URL}/${url}`,
        data: { reqData: data },
        params: { reqData: params },
        headers: HEADERS,
      })
        .then((response) => {
          resolve((response.data));
        })
        .catch((err) => {
          if (err.response?.data) {
            reject({ ...err.response, data: (err.response.data) });
          } else {
            reject({
              data: { message: err?.message || "Unknown Error Occurred" },
            });
          }
        });
    });

  const httpChatBotResponse = (method, url, data = {}, params) =>
    new Promise((resolve, reject) => {
      axios({
        method,
        url: `${BASE_URL}/${url}`,
        data: data,
        params: params,
        headers: HEADERS,
      })
        .then((response) => {
          resolve((response.data));
        })
        .catch((err) => {
          if (err.response?.data) {
            reject({ ...err.response, data: (err.response.data) });
          } else {
            reject({
              data: { message: err?.message || "Unknown Error Occurred" },
            });
          }
        });
    });

  const httpFormRequest = (method, url, data) =>
    new Promise((resolve, reject) => {
      axios({
        method,
        url: `${BASE_URL}/${url}`,
        data,
        headers: {
          ...HEADERS,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          if (err.response?.status === 401) {
            localStorage.removeItem("token");
          }
          if (err.response?.data) {
            reject({ ...err.response, data: err.response.data });
          } else {
            reject({
              data: { message: err?.message || "Unknown Error Occurred" },
            });
          }
        });
    });

  return { httpRequest, httpDecryptRequest, httpChatBotResponse, httpFormRequest };
};

export default HttpService;
